/**
 * Helpers for viewing and downloading attachments via direct Google Drive links.
 */

export const getAttachmentViewUrl = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item;
  return item.viewUrl || item.webViewLink || "";
};

export const getAttachmentDownloadUrl = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item;
  if (item.downloadUrl) return item.downloadUrl;
  if (item.driveFileId) {
    return `https://drive.google.com/uc?export=download&id=${item.driveFileId}`;
  }
  return "";
};

export const openAttachmentInNewTab = (item) => {
  const url = getAttachmentViewUrl(item);
  if (url) {
    window.open(url, "_blank");
    return true;
  }
  return false;
};

export const downloadAttachmentDirect = (item, fallbackName = "attachment") => {
  const url = getAttachmentDownloadUrl(item);
  if (url) {
    const fileName = (typeof item === "object" && item.fileName) ? item.fileName : fallbackName;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  }
  return false;
};
